import { Card, Tabs } from "antd";
import React, { useEffect } from "react";
import GeneralCashbook from "./GeneralCashbook";
import ProjectCashbook from "./ProjectCashbook";
import ProjectTrialBalance from "./ProjectTrialBalance";
import ProjectIncomeStatement from "./ProjectIncomeStatement";
import { useCashbookStore } from "../../../config/stores";
import { isEmpty } from "lodash";
import TrialBalance from "./TrialBalance";
import IncomeStatement from "./IncomeStatement";
import BalanceSheet from "./BalanceSheet";

const Cashbook = () => {
  const cashbookStore = useCashbookStore();

  useEffect(() => {
    if (isEmpty(cashbookStore.metadata)) cashbookStore.getMetaData();
  }, []);
  return (
    <div className="container-fluid p-2">
      <h5 className="fw-bold" style={{ marginLeft: "8px" }}>
        FINANCIAL REPORTS
      </h5>
      <Card>
        <Tabs
          tabBarStyle={{ marginBottom: 0 }}
          type="card"
          items={[
            {
              label: "GENERAL CASHBOOK",
              key: "general-cashbook",
              children: <GeneralCashbook />,
            },
            {
              label: "PROJECT CASHBOOK",
              key: "project-cashbook",
              children: <ProjectCashbook />,
            },
            {
              label: "TRIAL BALANCE",
              key: "trial-balance",
              children: <TrialBalance />,
            },
            {
              label: "PROJECT TRIAL BALANCE",
              key: "project-trial-balance",
              children: <ProjectTrialBalance />,
            },
            {
              label: "INCOME STATEMENT",
              key: "income-statement",
              children: <IncomeStatement />,
            },
            {
              label: "PROJECT INCOME STATEMENT",
              key: "project-income-statement",
              children: <ProjectIncomeStatement />,
            },
            {
              label: "BALANCE SHEET",
              key: "balance-sheet",
              children: <BalanceSheet />,
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default Cashbook;
